import resourcesToBackend from 'i18next-resources-to-backend';

export const i18nBackend = resourcesToBackend((language: string, namespace: string) => import(`locales/${language}/${namespace}.json`));

export const i18nSaveMissing = false;
